import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {  UseWalletProvider } from 'use-wallet'
import BlockchainProvider from "./BlockchainProvider"
import config from "./config"
// require('dotenv').config()


import { Provider } from 'react-redux'



ReactDOM.render(
  <React.StrictMode>
    <UseWalletProvider
    chainId={config.CHAINID}
   
  >
    <App />
   
  </UseWalletProvider>
   
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
